module.exports = __webpack_public_path__ + "img/dianshang-qq.c78fc371.png";